.container {
  border-radius: inherit;

  @media (prefers-reduced-motion: no-preference) {
    transition: box-shadow var(--dds-motion-micro-state);
  }
  &:has(.header-button:hover) {
    box-shadow: 0 0 0 2px var(--dds-color-border-action-hover);
  }
}

.header-button {
  transition: var(--dds-focus-transition);
}

.header-container {
  padding: var(--dds-card-accordion-header-container-padding);
}

.header__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-container__chevron {
  margin-left: var(--dds-spacing-x0-5);
}
